<template>
  <div class="HeaderTop">
    <div class="Top_box">
      <div class="Top_box_top">
        <div>
          <!-- 移动端汉堡菜单按钮 -->
          <div class="mobile-menu-button" @click="toggleDrawer">
            <i class="el-icon-s-unfold"></i>
          </div>

          <div class="Top_box_top" style="cursor: pointer" @click="goToHome">
            <img src="./img/logo.png" style="height: 48px" alt="" />
            <div class="B_t">{{ $t("header.industry.mall") }}</div>
          </div>

          <!-- 桌面端菜单 -->
          <div class="menust desktop-menu">
            <el-menu
              :default-active="activeIndex"
              class="el-menu-demo"
              mode="horizontal"
              @select="handleSelect"
            >
              <el-menu-item index="0" v-if="showHomeMenu">{{
                $t("header.home")
              }}</el-menu-item>
              <el-menu-item index="1" v-if="showAppMenu">{{
                $t("header.solutions.apps")
              }}</el-menu-item>
              <el-menu-item index="2" v-if="showComponentMenu">
                {{ $t("header.learning.center") }}
              </el-menu-item>
              <el-menu-item index="3" v-if="showPartnerMenu">{{
                $t("header.partner.portal")
              }}</el-menu-item>
              <el-menu-item index="4" v-if="showPricingMenu">{{
                $t("header.pricing.plan")
              }}</el-menu-item>
            </el-menu>
          </div>
        </div>
        <div>
          <!--多语言切换-->
          <el-dropdown
            v-if="showLanguageSwitcher"
            trigger="click"
            class="lang"
            @command="changeLang"
          >
            <span class="el-dropdown-link">
              <span>{{ this.language[curLang] }}</span>
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="'zh'">中文</el-dropdown-item>
              <el-dropdown-item :command="'en'">English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <!-- 头像下拉菜单 -->
          <el-dropdown
            v-if="showUserInfo"
            trigger="click"
            :class="[
              'user-avatar',
              { 'logged-in': isLogin, 'logged-out': !isLogin },
            ]"
            @command="handleUserCommand"
          >
            <div class="avatar-wrapper">
              <!-- 优先显示用户头像图片 -->
              <img
                v-if="isLogin && userInfo && userInfo.userAvatar && userInfo.userAvatar !== 'null' && userInfo.userAvatar !== ''"
                :src="getAvatarUrl(userInfo.userAvatar)"
                alt="用户头像"
                class="avatar-image"
              />
              <!-- 没有头像时显示默认图标 -->
              <i
                v-else
                :class="[
                  'avatar-icon',
                  isLogin ? 'el-icon-user-solid' : 'el-icon-user',
                ]"
              ></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <!-- 已登录状态显示的菜单项 -->
              <template v-if="isLogin">
                <el-dropdown-item command="name" disabled>
                  {{ userInfo.userName || "" }}
                </el-dropdown-item>
                <el-dropdown-item command="email" disabled>
                  {{ userInfo.email || "" }}
                </el-dropdown-item>
                <el-dropdown-item command="personal">
                  <i class="el-icon-user-solid"></i>
                  {{ $t("resource.app.store.title") }}
                </el-dropdown-item>
                <!-- <el-dropdown-item command="orders">
                  <i class="el-icon-s-order"></i>
                  {{ $t("header.my.orders") }}
                </el-dropdown-item>
                <el-dropdown-item command="invoice">
                  <i class="el-icon-s-ticket"></i>
                  {{ $t("我的发票") }}
                </el-dropdown-item> -->
                <el-dropdown-item command="loginCloudCC">
                  <i class="el-icon-s-home"></i>
                  {{ $t("header.login.cloudcc") }}
                </el-dropdown-item>
                <el-dropdown-item divided command="logout">
                  <i class="el-icon-switch-button"></i>
                  {{ $t("header.logout") }}
                </el-dropdown-item>
              </template>

              <!-- 未登录状态显示的菜单项 -->
              <template v-else>
                <el-dropdown-item command="loginAppstore">
                  <div>
                    <i class="el-icon-s-shop"></i>
                    {{ $t("header.login.industry.mall") }}
                  </div>
                  <div class="description">{{ $t("header.industry.demo") }}</div>
                </el-dropdown-item>
                <el-dropdown-item divided command="loginCloudCC">
                  <div>
                    <i class="el-icon-s-home"></i>
                    {{ $t("header.login.cloudcc") }}
                  </div>
                  <div class="description">
                    {{ $t("header.login.your.crm") }}
                  </div>
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="box-right">
        <el-input
          :placeholder="$t('header.search')"
          v-model="input3"
          class="input-with-select"
          prefix-icon="el-icon-search"
          @keyup.enter.native="handleInput"
          @clear="handleInput"
          clearable
        >
        </el-input>
      </div>
    </div>

    <!-- 协议 -->
    <el-dialog
      :visible.sync="isShowAgreement"
      @before-close="closeAgreement"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="45%"
    >
      <Agreement
        ref="agreement"
        @agreeCancel="closeAgreement"
        @agreeProceed="agree"
      />
    </el-dialog>

    <!-- 移动端抽屉菜单 -->
    <el-drawer
      :visible.sync="drawerVisible"
      direction="ltr"
      :with-header="false"
      :modal="false"
      :close-on-click-modal="false"
      size="280px"
      class="mobile-drawer"
    >
      <div class="drawer-content">
        <!-- 抽屉头部 -->
        <div class="drawer-header">
          <div class="drawer-logo">
            <img src="./img/logo.png" alt="" />
            <span>{{ $t("header.industry.mall") }}</span>
          </div>
          <el-button type="text" @click="toggleDrawer" class="close-btn">
            <i class="el-icon-close"></i>
          </el-button>
        </div>

        <!-- 抽屉菜单项 -->
        <div class="drawer-menu">
          <div
            v-if="showHomeMenu"
            class="drawer-menu-item"
            :class="{ active: activeIndex === '0' }"
            @click="handleDrawerSelect('0')"
          >
            <i class="el-icon-s-home"></i>
            <span>{{ $t("header.home") }}</span>
          </div>

          <div
            v-if="showAppMenu"
            class="drawer-menu-item"
            :class="{ active: activeIndex === '1' }"
            @click="handleDrawerSelect('1')"
          >
            <i class="el-icon-s-shop"></i>
            <span>{{ $t("header.solutions.apps") }}</span>
          </div>

          <div
            v-if="showComponentMenu"
            class="drawer-menu-item"
            @click="handleDrawerSelect('2')"
          >
            <i class="el-icon-reading"></i>
            <span>{{ $t("header.learning.center") }}</span>
          </div>

          <div
            v-if="showPartnerMenu"
            class="drawer-menu-item"
            @click="handleDrawerSelect('3')"
          >
            <i class="el-icon-user"></i>
            <span>{{ $t("header.partner.portal") }}</span>
          </div>
          <div
            v-if="showPricingMenu"
            class="drawer-menu-item"
            @click="handleDrawerSelect('4')"
          >
            <i class="el-icon-price-tag"></i>
            <span>{{ $t("header.pricing.plan") }}</span>
          </div>
        </div>

        <!-- 抽屉底部 -->
        <div class="drawer-footer">
          <!-- 语言切换 -->
          <div v-if="showLanguageSwitcher" class="drawer-lang">
            <span class="lang-title">语言 / Language</span>
            <div class="lang-options">
              <div
                class="lang-option"
                :class="{ active: curLang === 'zh' }"
                @click="changeLang('zh')"
              >
                中文
              </div>
              <div
                class="lang-option"
                :class="{ active: curLang === 'en' }"
                @click="changeLang('en')"
              >
                English
              </div>
            </div>
          </div>

          <!-- 用户信息 -->
          <div v-if="showUserInfo" class="drawer-user">
            <template v-if="isLogin">
              <div class="user-info">
                <i class="el-icon-user-solid"></i>
                <span>{{ userInfo.userName || "" }}</span>
              </div>
              <div class="user-actions">
                <div @click="handleUserCommand('personal')">
                  {{ $t("resource.app.store.title") }}
                </div>
                <div @click="handleUserCommand('loginCloudCC')">
                  {{ $t("header.login.cloudcc") }}
                </div>
                <div @click="handleUserCommand('logout')">
                  {{ $t("header.logout") }}
                </div>
              </div>
            </template>
            <template v-else>
              <div class="login-actions">
                <div @click="handleUserCommand('loginAppstore')">
                  {{ $t("header.login.industry.mall") }}
                </div>
                <div @click="handleUserCommand('loginCloudCC')">
                  {{ $t("header.login.cloudcc") }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import debounce from "lodash.debounce";
import mixin from "./mixin";
import Agreement from "@/components/Agreement/index.vue";
export default {
  name: "",
  mixins: [mixin],
  components: {
    Agreement,
  },
  props: {
    showHomeMenu: {
      type: Boolean,
      default: true,
    },
    showAppMenu: {
      type: Boolean,
      default: true,
    },
    showComponentMenu: {
      type: Boolean,
      default: true,
    },
    showPartnerMenu: {
      type: Boolean,
      default: true,
    },
    showPricingMenu: {
      type: Boolean,
      default: true,
    },
    showLanguageSwitcher: {
      type: Boolean,
      default: false,
    },
    showUserInfo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      activeIndex: "0",
      input3: "",
      curLang: "en",
      language: {
        zh: "中文",
        en: "English",
        jp: "日本語",
      },
      // 搜索防抖定时器
      searchDebounceTimer: null,
      isShowAgreement: false,
      // 移动端抽屉菜单状态
      drawerVisible: false,
    };
  },
  created() {
    // 监听openPartnerUrl事件
    this.$bus.$on("openPartnerUrl", this.openPartnerUrl);
    // 监听事件总线上的updateHeaderActiveIndex事件
    this.$bus.$on("updateHeaderActiveIndex", (index) => {
      this.activeIndex = index;
    });
    // 监听刷新用户信息事件
    this.$bus.$on("refreshHeaderUserInfo", this.initUserInfo);
    // 初始化时设置正确的activeIndex
    this.setActiveIndexByRoute();
  },
  beforeDestroy() {
    // 移除事件监听
    this.$bus.$off("openPartnerUrl", this.openPartnerUrl);
    // 移除事件监听
    this.$bus.$off("updateHeaderActiveIndex");
    // 移除刷新用户信息事件监听
    this.$bus.$off("refreshHeaderUserInfo", this.initUserInfo);
    // 清理外部点击监听器
    this.removeOutsideClickListener();
  },
  watch: {
    // 监听路由变化
    $route(to, from) {
      this.setActiveIndexByRoute();
    },
  },
  methods: {
    // 根据当前路由设置activeIndex
    setActiveIndexByRoute() {
      const currentPath = this.$route.path;
      if (currentPath === "/home" || currentPath === "/") {
        this.activeIndex = "0";
      } else if (
        currentPath === "/allApps" ||
        currentPath.startsWith("/appDetail/")
      ) {
        this.activeIndex = "1";
      } else {
        // 对于其他路由，保持当前的activeIndex不变
        // 或者根据需要设置默认值
      }
    },
    // 菜单选择处理
    handleSelect(val) {
      if (val == "0") {
        this.$router.push({
          path: "/home",
        });
      } else if (val == "1") {
        this.$router.push({
          path: "/allApps",
        });
      } else if (val == "2") {
        // 打开学习菜单 - 新标签页打开
        const learningUrl = window.Glod.LEARNING_URL || "https://blackhole-help.cloudcc.cn/";
        window.open(learningUrl, "_blank");
        // 阻止菜单选中状态，保持原有的activeIndex不变
        this.$nextTick(() => {
          // 强制刷新菜单，移除选中状态
          const currentActive = this.activeIndex;
          this.activeIndex = "";
          this.$nextTick(() => {
            this.activeIndex = currentActive;
          });
        });
      } else if (val == "3") {
        this.openPartnerUrl();
        // 阻止菜单选中状态，保持原有的activeIndex不变
        this.$nextTick(() => {
          // 强制刷新菜单，移除选中状态
          const currentActive = this.activeIndex;
          this.activeIndex = "";
          this.$nextTick(() => {
            this.activeIndex = currentActive;
          });
        });
      } else if (val == "4") {
        // 打开产品定价菜单 - 新标签页打开
        // const pricingUrl = window.Glod.PRICING_URL || "https://help.cloudcc.cn/product01/chan-pin-ding-jie/";
        // window.open(pricingUrl, "_blank");
        // 阻止菜单选中状态，保持原有的activeIndex不变
        // this.$nextTick(() => {
        //   // 强制刷新菜单，移除选中状态
        //   const currentActive = this.activeIndex;
        //   this.activeIndex = "";
        //   this.$nextTick(() => {
        //     this.activeIndex = currentActive;
        //   });
        // });
        this.$router.push({
          path: "/pricing",
        });
      }
    },
    // 进入伙伴门户系统
    openPartnerUrl() {
      //未登录商城，需要跳转社区登录页登录
      //已登录，但是还不是伙伴，弹出申请说明，跟注册其他系统须知那个东西
      //已经登录，并且是伙伴，点击跳转到伙伴门户（文娟新开发的系统）
      if (this.isLogin) {
        let isPartner = this.userInfo.isFormalPartner;
        if (isPartner == true) {
          // 已经登录，并且是伙伴，点击跳转到伙伴门户（文娟新开发的系统）
          window.open(`${window.Glod.PARTNERPORTAL_URL}`, "_blank");
        } else {
          // 已经登录，但是还不是伙伴，弹出申请说明，跟注册其他系统须知那个东西
          this.isShowAgreement = true;
        }
      } else {
        // 未登录商城，需要跳转社区登录页登录
        this.handleLogin("Appstore");
      }
    },
    // 关闭协议
    closeAgreement() {
      this.isShowAgreement = false;
    },
    // 点击商城图标返回首页
    goToHome() {
      this.$router.push("/");
    },
    // 已同意协议
    agree() {
      this.isShowAgreement = false;
      // 提示用户，申请成功，请等待审核
      this.$message.success(this.$i18n.t("header.congrats.formal.partner"));
      // 需要更新CCDK里的CCUser里的isFormalPartner字段，使之变为true
      this.userInfo.isFormalPartner = true;
      window.$CCDK.CCUser.setUserInfo(
        this.userInfo,
        undefined,
        "partnerUserInfo"
      );
      // 进入伙伴门户
      setTimeout(() => {
        window.open(window.Glod.PARTNERPORTAL_URL, "_blank");
      }, 1000);
    },
    /**搜索 */
    handleInput() {
      this.$emit("handleInput", this.input3);
    },

    /**防抖搜索 */
    handleInputDebounced: debounce(function () {
      this.handleInput();
    }, 500),

    /**头像菜单点击处理 */
    handleUserCommand(command) {
      switch (command) {
        case "orders":
          // 跳转到我的订单页面
          this.$router.push({
            path: "/myApps",
          });
          break;
        case "invoice":
          // 跳转到我的订单页面
          this.$router.push({
            path: "/invoice",
          });
          break;
        case "personal":
          // 跳转到我的订单页面
          this.$router.push({
            path: "/personal",
          });
          break;
        case "loginCloudCC":
          this.handleLogin("CloudCC");
          break;
        case "loginAppstore":
          this.handleLogin("Appstore");
          break;
        case "name":
          break;
        case "email":
          break;
        case "logout":
          window.$CCDK.CCToken.clearToken("partnerToken");
          window.$CCDK.CCUser.clearUserInfo("partnerUserInfo");
          this.isLogin = false;
          setTimeout(() => {
            this.$message.success(this.$i18n.t("header.logout.success"));
          }, 1000);
          break;
      }
    },
    // 登录
    handleLogin(type) {
      if (type == "CloudCC") {
        // crm登录:进入CRM系统
        window.location.href = window.Glod.loginURL;
      } else if (type == "Appstore") {
        // 社区登录:重定向到商城
        const currentUrl = window.location.href;
        const redirectParam = encodeURIComponent(currentUrl);
        // 构建登录URL
        const loginUrl = `${window.Glod.PARTNER_LOGIN_URL}?redirectionRouteAppstore=${redirectParam}&type=mall&language=${this.curLang}`;
        window.location.href = loginUrl;
      }
    },

    // 移动端抽屉菜单相关方法
    toggleDrawer() {
      this.drawerVisible = !this.drawerVisible;

      // 如果打开抽屉，添加页面点击监听
      if (this.drawerVisible) {
        this.$nextTick(() => {
          this.addOutsideClickListener();
        });
      } else {
        this.removeOutsideClickListener();
      }
    },

    // 添加点击外部区域关闭抽屉的监听
    addOutsideClickListener() {
      document.addEventListener("click", this.handleOutsideClick, true);
    },

    // 移除外部点击监听
    removeOutsideClickListener() {
      document.removeEventListener("click", this.handleOutsideClick, true);
    },

    // 处理点击外部区域
    handleOutsideClick(event) {
      const drawer = document.querySelector(".mobile-drawer .el-drawer");
      const menuButton = document.querySelector(".mobile-menu-button");

      if (
        drawer &&
        !drawer.contains(event.target) &&
        menuButton &&
        !menuButton.contains(event.target)
      ) {
        this.drawerVisible = false;
        this.removeOutsideClickListener();
      }
    },

    // 抽屉菜单选择处理
    handleDrawerSelect(val) {
      this.handleSelect(val);
      this.drawerVisible = false; // 选择后关闭抽屉
      this.removeOutsideClickListener();
    },

    /**多语言切换 */
    changeLang(val) {
      this.$i18n.locale = val;
      this.curLang = val;
      // 如果抽屉打开，语言切换后也关闭抽屉
      if (this.drawerVisible) {
        this.drawerVisible = false;
      }
    },

    /**
     * 获取头像URL
     * @param {string} avatarId - 头像文件ID
     * @returns {string} 头像预览URL
     */
    getAvatarUrl(avatarId) {
      if (!avatarId) return "";
      const baseUrl = window.Glod["ccex-api-svc"];
      const token = window.$CCDK.CCToken.getToken("binding", "partnerToken");
      return `${baseUrl}/api/file/viewImg?id=${avatarId}&accessToken=${token}`;
    },
  },
};
</script>
<style lang="scss" scoped>
// PC端
.HeaderTop {
  background: #ffffff;
  height: auto;
  min-height: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0px !important;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.12);

  .Top_box {
    width: 100%;
    max-width: 1200px;
    .Top_box_top {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 10px;
      > div {
        padding: 0px 4px;
        display: flex;
        align-items: center;
        flex-shrink: 0;

        // 确保右侧容器（包含头像）有足够空间
        &:last-child {
          min-width: fit-content;
        }
      }
      .lang {
        font-size: 16px;
        cursor: pointer;
        padding-right: 10px;
        flex-shrink: 0; // 防止语言切换被压缩
      }
      .B_t {
        font-size: 16px;
        font-weight: bold;
        color: #006dcc;
        white-space: nowrap;
      }

      .menust {
        .el-menu {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          gap: 10px;
          border: none;
          align-items: center;
          .el-menu-item {
            padding: 8px 8px;
            font-size: 14px;
            color: #006dcc !important;
            border: none;
            margin: 0;
            height: auto;
            line-height: 1;

            &:hover {
              background: transparent !important;
            }

            &.is-active {
              background: transparent !important;
              border-bottom: 2px solid #006dcc !important;
            }
          }
        }
      }
    }
  }
  .box-right {
    margin-top: 12px;
  }
}

// 头像相关样式
.user-avatar {
  cursor: pointer;
  flex-shrink: 0; // 防止头像在小屏幕下被压缩

  .avatar-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border-radius: 50%;
    transition: all 0.3s ease;
    min-width: 40px; // 确保最小宽度
    min-height: 40px; // 确保最小高度
    width: 40px; // 确保最小宽度
    height: 40px; // 确保最小高度

    .avatar-icon {
      font-size: 24px;
      transition: all 0.3s ease;
      line-height: 1; // 确保图标垂直居中
    }

    .avatar-image {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
      transition: all 0.3s ease;
    }

    .avatar-arrow {
      margin-left: 5px;
      font-size: 12px;
      color: #666;
      transition: transform 0.3s;
    }
  }

  // 登录状态样式
  &.logged-in {
    .avatar-wrapper {
      background-color: #f0f9ff;
      border: 1px solid #0ea5e9;

      .avatar-icon {
        color: #0ea5e9;
      }

      &:hover {
        background-color: #e0f2fe;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(14, 165, 233, 0.2);
      }
    }
  }

  // 未登录状态样式
  &.logged-out {
    .avatar-wrapper {
      background-color: #f8f9fa;
      border: 1px solid #6c757d;

      .avatar-icon {
        color: #6c757d;
      }

      &:hover {
        background-color: #e9ecef;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(108, 117, 125, 0.2);

        .avatar-icon {
          color: #6c757d;
        }
      }
    }
  }

  &.is-active .avatar-arrow {
    transform: rotate(180deg);
  }
}

// 下拉菜单样式优化
::v-deep .el-dropdown-menu {
  .el-dropdown-menu__item {
    display: flex;
    align-items: center;
    i {
      margin-right: 8px;
      font-size: 14px;
    }
  }
}

// 描述文字样式
.description {
  font-size: 12px;
  color: #999;
  line-height: 20px;
  max-width: 220px;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

// 媒体查询 - 小屏幕时隐藏.B_t
@media screen and (max-width: 768px) {
  .B_t {
    display: none !important;
  }
  .box-right {
    margin: 0 8px !important;
  }

  // 小屏幕下头像样式优化
  .user-avatar {
    .avatar-wrapper {
      padding: 0 !important;
      border-radius: 50% !important;

      .avatar-icon {
        font-size: 20px !important;
      }

      .avatar-image {
        width: 20px !important;
        height: 20px !important;
      }
    }

    // 确保登录状态和未登录状态在小屏幕下都能正常显示
    &.logged-in .avatar-wrapper {
      border-width: 1px !important;
      box-shadow: 0 2px 4px rgba(14, 165, 233, 0.1) !important;
    }

    &.logged-out .avatar-wrapper {
      border-width: 1px !important;
      box-shadow: 0 2px 4px rgba(108, 117, 125, 0.1) !important;
    }
  }
}

// 更小屏幕（手机端）下的进一步优化
@media screen and (max-width: 480px) {
  .user-avatar {
    .avatar-wrapper {
      padding: 0 !important;
      border-radius: 50% !important;
      min-width: 32px !important;
      min-height: 32px !important;

      .avatar-icon {
        font-size: 18px !important;
      }

      .avatar-image {
        width: 18px !important;
        height: 18px !important;
      }
    }
  }

  // 头部整体布局在手机端的调整
  .HeaderTop {
    padding: 8px 0px !important;
    min-height: 60px !important;
  }

  .Top_box .Top_box_top {
    gap: 5px !important;

    > div {
      padding: 0px 2px !important;
    }
  }
}

// 移动端汉堡菜单按钮
.mobile-menu-button {
  display: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: transparent;
  border: none;
  cursor: pointer;
  margin-right: 8px;
  border-radius: 6px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(0, 109, 204, 0.1);
  }

  i {
    font-size: 20px;
    color: #006dcc;
  }

  @media screen and (max-width: 768px) {
    display: flex;
  }
}

// 桌面端菜单在移动端隐藏
.desktop-menu {
  @media screen and (max-width: 768px) {
    display: none !important;
  }
}

// 移动端抽屉菜单样式
::v-deep .mobile-drawer {
  .el-drawer {
    border-radius: 0 16px 16px 0;
    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.15);
    border: 1px solid #e5e7eb;
    border-left: none;
  }

  .el-drawer__body {
    padding: 0;
    overflow: hidden;
  }

  // 无蒙版时的样式调整
  .el-drawer__wrapper {
    outline: none;
    background: transparent;
  }

  // 增强抽屉的阴影效果以提高层级感
  .el-drawer__container {
    background: transparent;
  }
}

.drawer-content {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
}

// 抽屉头部
.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;

  .drawer-logo {
    display: flex;
    align-items: center;
    gap: 12px;

    img {
      height: 32px;
    }

    span {
      font-size: 16px;
      font-weight: bold;
      color: #006dcc;
    }
  }

  .close-btn {
    font-size: 18px;
    color: #666;
    padding: 4px;

    &:hover {
      color: #006dcc;
    }
  }
}

// 抽屉菜单
.drawer-menu {
  flex: 1;
  padding: 16px 0;

  .drawer-menu-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    border-left: 3px solid transparent;

    &:hover {
      background: rgba(0, 109, 204, 0.05);
      border-left-color: rgba(0, 109, 204, 0.3);
    }

    &.active {
      background: rgba(0, 109, 204, 0.1);
      border-left-color: #006dcc;
      color: #006dcc;
    }

    i {
      font-size: 18px;
      color: #666;
      width: 20px;
      text-align: center;
    }

    span {
      font-size: 15px;
      font-weight: 500;
    }

    &.active i {
      color: #006dcc;
    }
  }
}

// 抽屉底部
.drawer-footer {
  padding: 20px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;

  .drawer-lang {
    margin-bottom: 20px;

    .lang-title {
      display: block;
      font-size: 14px;
      color: #666;
      margin-bottom: 12px;
    }

    .lang-options {
      display: flex;
      gap: 12px;

      .lang-option {
        padding: 8px 16px;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        transition: all 0.3s ease;

        &:hover {
          border-color: #006dcc;
          color: #006dcc;
        }

        &.active {
          background: #006dcc;
          border-color: #006dcc;
          color: #fff;
        }
      }
    }
  }

  .drawer-user {
    .user-info {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 0;
      border-bottom: 1px solid #eee;
      margin-bottom: 12px;

      i {
        font-size: 16px;
        color: #006dcc;
      }

      span {
        font-weight: 500;
        color: #333;
      }
    }

    .user-actions,
    .login-actions {
      display: flex;
      flex-direction: column;
      gap: 8px;

      div {
        padding: 10px 0;
        cursor: pointer;
        font-size: 14px;
        color: #666;
        border-bottom: 1px solid #f0f0f0;
        transition: color 0.3s ease;

        &:hover {
          color: #006dcc;
        }

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style>